import { Dialog, DialogContent, CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';

import { BoxFlex } from '@woovi/ui';

import useStoreContext from '../store/useStoreContext.tsx';

export type DialogPixLoadingProps = {
  isOpen: boolean;
};
const DialogPixLoading = ({ isOpen }: DialogPixLoadingProps): ReactNode => {
  const { openPixState } = useStoreContext();

  if (!openPixState.modal) {
    return (
      <BoxFlex sx={{ justifyContent: 'center' }}>
        <CircularProgress data-testid='circular-loading' />
      </BoxFlex>
    );
  }

  return (
    <Dialog open={isOpen}>
      <DialogContent>
        <CircularProgress data-testid='circular-loading' />
      </DialogContent>
    </Dialog>
  );
};

export default DialogPixLoading;
